import React, { useState } from 'react';

import MonthPickerItem from './MonthPickerItem';
interface Props {
  load: any;
  months: Array<MonthlyReportDate>;
  year: string;
  open: boolean;
}

const Year = (props) => (
  <li className="date-item date" role="button" onClick={() => props.onClick()}>
    <div className="menu-text">{props.year}</div>
  </li>
);

function MonthMenuYear(props: Props) {
  const [show, setShow] = useState(props.open);
  return (
    <div>
      <Year onClick={() => setShow(!show)} year={props.year} />
      {show ? (
        <div>
          {props.months
            .sort((a, b) => b.month - a.month)
            .map((item: MonthlyReportDate) => (
              <MonthPickerItem date={item} load={(date) => props.load(date)} />
            ))}
        </div>
      ) : null}
    </div>
  );
}

export default MonthMenuYear;
